// Module
var code = `<div class="row">
	<div class="col-12 scrollable-column">
		<div class="mb-2">
			<library-media-labels></library-media-labels>
		</div>
		<div class="mb-2">
			<library-file-media></library-file-media>
		</div>
		<div class="mb-2">
			<library-social-media></library-social-media>
		</div>
		<div class="mb-2">
			<library-service-announcements></library-service-announcements>
		</div>
	</div>
</div>
`;
// Exports
export default code;